module.exports = __webpack_public_path__ + "img/Villa_Borna_41.eebec840.jpg";